import React from 'react';
import { PageHero } from '../components/PageHero';
import { TherapistCard } from '../components/TherapistCard';
import { THERAPISTS, THERAPISTS_HERO } from '../data/therapists';
export function Therapists() {
  return <main className="w-full bg-ink-950" data-id="element-428" data-mp="2czftqpp33hwe">
      <PageHero image={THERAPISTS_HERO} eyebrow="The Team" title="Our Ladies" accent="Ladies" subtitle="Experienced therapists from across East and Southeast Asia — each with her own touch." note="Ask for anyone by name when you book. Services for men only, ages 18+." data-id="element-429" data-mp="2d0qtmefes5i8" />

      <section aria-label="Our therapists" className="glow-warm w-full bg-ink-950" data-id="element-430" data-mp="1u855kgaqtj87">
        <div className="mx-auto grid w-full max-w-7xl gap-6 px-5 py-24 sm:grid-cols-2 sm:px-8 lg:grid-cols-3" data-id="element-431" data-mp="1y9ib0p9xbkel">
          {THERAPISTS.map((therapist, i) => <TherapistCard key={therapist.slug} therapist={therapist} index={i} data-id="element-432" data-mp="35mil8xvcesd5" data-mpi={i} />)}
        </div>
      </section>
    </main>;
}